import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/inputNumberConfig';
import App from './App';

console.log('FRONTEND STATUS MODEL UNIFIED');

// Инициализация Sentry (по env-флагу)
if (process.env.REACT_APP_SENTRY_DSN) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Sentry = require('@sentry/react');
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { BrowserTracing } = require('@sentry/tracing');
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new BrowserTracing()],
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES || 0.1),
      environment: process.env.NODE_ENV,
    });
  } catch {}
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);